import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('ProgressBar').create(() => ({
  fulfilledArea: {
    display: 'flex',
    position: 'absolute',
    borderRadius: '12px',
    backgroundColor: 'rgba(243, 202, 20, 0.1)',
    zIndex: 5,
    height: '100%',
    left: '0',
    maxWidth: '100%',
    transition: 'width 0.3s ease',
    '&[data-isgrey=true]': {
      backgroundColor: 'rgba(176, 177, 184, 0.12)',
    },
  },
}))
